module.exports = __webpack_public_path__ + "img/b_Forsmax_right.51eb13be.jpeg";